import { useQuery } from 'react-query'
import { getJobScheduleEvents } from './jobScheduleApi'

export const useJobScheduleEventsQuery = (jobId: number) => {
  return useQuery(['jobScheduleEvents', { jobId }], {
    queryFn: () => getJobScheduleEvents(jobId),
    enabled: !!jobId,
    refetchOnWindowFocus: false
  })
}
